"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApKPIWidgetTable = void 0;
var React = require("react");
var styles_1 = require("./styles");
var ALL_HEADER = ['', 'Current period', 'Prev period', 'Change'];
var TOP_HEADER = ['', 'Current period', 'Prev period', 'Change'];
var BOTTOM_HEADER = ['', '', '', ''];
var rowRenderer = function (expanded) {
    var renderer = function (tableItem, index) {
        var title = tableItem.title, current = tableItem.current, prev = tableItem.prev, change = tableItem.change, trend = tableItem.trend, isUpTrendNegative = tableItem.isUpTrendNegative;
        return expanded ? (React.createElement("tr", { key: title + index },
            React.createElement(styles_1.WithEllipsis, null,
                React.createElement("span", null, title)),
            React.createElement("td", null, current),
            React.createElement("td", null, prev),
            React.createElement("td", null,
                React.createElement(styles_1.ChangeOverTime, { value: change, trend: trend, isUpTrendNegative: isUpTrendNegative })))) : (React.createElement("tr", { key: title + index },
            React.createElement(styles_1.WithEllipsis, null,
                React.createElement("span", null, title)),
            React.createElement("td", null, current)));
    };
    return renderer;
};
var getHeaders = function (expanded, name) {
    var allHeader = expanded ? __spread(ALL_HEADER) : ALL_HEADER.slice(0, 2);
    var topHeader = expanded ? __spread(TOP_HEADER) : TOP_HEADER.slice(0, 2);
    var bottomHeader = expanded ? __spread(BOTTOM_HEADER) : BOTTOM_HEADER.slice(0, 2);
    allHeader[0] = name;
    topHeader[0] = name + " (Top 3)";
    bottomHeader[0] = name + " (Bottom 3)";
    return { allHeader: allHeader, topHeader: topHeader, bottomHeader: bottomHeader };
};
exports.ApKPIWidgetTable = function (_a) {
    var expanded = _a.expanded, data = _a.data, name = _a.name, props = __rest(_a, ["expanded", "data", "name"]);
    var _b = getHeaders(!!expanded, name), allHeader = _b.allHeader, topHeader = _b.topHeader, bottomHeader = _b.bottomHeader;
    if (!data) {
        return null;
    }
    return (React.createElement(styles_1.Table, __assign({}, props), data.all ? (React.createElement(React.Fragment, null,
        React.createElement(styles_1.TableTopHeader, null, allHeader.map(function (header, index) { return (React.createElement("th", { key: header + index }, header)); })),
        data.all.map(rowRenderer(expanded)))) : (React.createElement(React.Fragment, null,
        React.createElement(styles_1.TableTopHeader, null, topHeader.map(function (header, index) { return (React.createElement("th", { key: header + index }, header)); })),
        data.top && data.top.map(rowRenderer(expanded)),
        React.createElement(styles_1.TableBottomHeader, null, bottomHeader.map(function (header, index) { return (React.createElement("th", { key: header + index }, header)); })),
        data.bottom && data.bottom.map(rowRenderer(expanded))))));
};
//# sourceMappingURL=ApKPIWidgetTable.js.map